module.exports = __webpack_public_path__ + "media/images/countrysquared/th-47e17ba06e1caaed1539fcc8d75cc851.svg";